export interface ComicChapter {
  id: string;
  title: string;
  updateTime: string;
}

export interface ComicItem {
  id: string;
  title: string;
  author: string;
  category: string;
  categorySlug: string;
  coverImage: string;
  description: string;
  status: string;
  rating: number;
  views: number;
  tags: string[];
  updateTime: string;
  latestChapter: string;
  chapters: ComicChapter[];
  isHot: boolean;
  isNew: boolean;
  isRecommended: boolean;
}

export const categories = [
  { name: '韩漫', slug: 'hanman', icon: 'ri-global-line', count: 128 },
  { name: '日漫', slug: 'riman', icon: 'ri-sun-line', count: 256 },
  { name: '国漫', slug: 'guoman', icon: 'ri-fire-line', count: 189 },
  { name: '耽美', slug: 'danmei', icon: 'ri-hearts-line', count: 86 },
  { name: '百合', slug: 'baihe', icon: 'ri-women-line', count: 42 },
  { name: '奇幻', slug: 'qihuan', icon: 'ri-magic-line', count: 95 },
  { name: '恋爱', slug: 'lianai', icon: 'ri-heart-pulse-line', count: 134 },
  { name: '动作', slug: 'dongzuo', icon: 'ri-sword-line', count: 78 },
  { name: '悬疑', slug: 'xuanyi', icon: 'ri-search-eye-line', count: 56 },
  { name: '搞笑', slug: 'gaoxiao', icon: 'ri-emotion-laugh-line', count: 67 },
];

export const comics: ComicItem[] = [
  {
    id: 'comic-1',
    title: '女神降临',
    author: '喵喵',
    category: '韩漫',
    categorySlug: 'hanman',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20webtoon%20style%20cover%20art%20featuring%20a%20stunning%20young%20woman%20with%20long%20dark%20hair%20and%20elegant%20makeup%2C%20soft%20romantic%20atmosphere%20with%20cherry%20blossom%20petals%2C%20clean%20minimalist%20background%20in%20pastel%20pink%20and%20cream%20tones%2C%20Korean%20manhwa%20aesthetic%2C%20vertical%20portrait%20composition%2C%20illustration%20style%20with%20delicate%20linework&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    description: '从小因为外貌被欺负的任晶晶，通过化妆技术华丽变身成为校园女神。然而，素颜的秘密能否一直隐藏？一场关于颜值与真心的青春恋爱故事就此展开。当两个截然不同的男生同时闯入她的生活，她该如何抉择？',
    status: '连载中',
    rating: 9.5,
    views: 18500000,
    tags: ['恋爱', '校园', '逆袭', '化妆'],
    updateTime: '2026-08-04',
    latestChapter: '第218话',
    chapters: Array.from({ length: 218 }, (_, i) => ({
      id: `ch-1-${i + 1}`,
      title: `第${i + 1}话`,
      updateTime: `2026-${String(Math.max(1, 8 - Math.floor(i / 30))).padStart(2, '0')}-${String(Math.max(1, 30 - (i % 30))).padStart(2, '0')}`,
    })),
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 'comic-2',
    title: '鬼灭之刃',
    author: '吾峠呼世晴',
    category: '日漫',
    categorySlug: 'riman',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Japanese%20manga%20cover%20art%20featuring%20a%20young%20warrior%20boy%20with%20a%20green%20and%20black%20checkered%20haori%20jacket%20holding%20a%20katana%20sword%2C%20intense%20action%20pose%2C%20traditional%20Japanese%20wave%20pattern%20background%20in%20deep%20blue%20and%20teal%20tones%2C%20dramatic%20lighting%2C%20shonen%20manga%20aesthetic%2C%20clean%20composition&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    description: '大正时期，少年灶门炭治郎一家惨遭鬼杀害，唯一幸存的妹妹祢豆子却变成了鬼。为了寻找让妹妹恢复成人的方法，炭治郎踏上了成为鬼杀队剑士的道路。一场人与鬼的悲壮战斗拉开帷幕。',
    status: '已完结',
    rating: 9.8,
    views: 52000000,
    tags: ['动作', '热血', '奇幻', '少年'],
    updateTime: '2026-07-15',
    latestChapter: '第205话（完）',
    chapters: Array.from({ length: 205 }, (_, i) => ({
      id: `ch-2-${i + 1}`,
      title: `第${i + 1}话`,
      updateTime: `2025-${String(Math.max(1, 12 - Math.floor(i / 20))).padStart(2, '0')}-${String(Math.max(1, 28 - (i % 28))).padStart(2, '0')}`,
    })),
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 'comic-3',
    title: '斗罗大陆',
    author: '唐家三少',
    category: '国漫',
    categorySlug: 'guoman',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Chinese%20donghua%20style%20cover%20illustration%20featuring%20a%20handsome%20young%20man%20in%20blue%20martial%20arts%20robe%20with%20spirit%20rings%20glowing%20around%20him%2C%20fantasy%20cultivation%20world%20background%20with%20mystical%20mountains%20and%20floating%20islands%2C%20golden%20energy%20effects%2C%20Chinese%20manhua%20aesthetic%2C%20epic%20composition%2C%20clean%20illustration%20style&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    description: '唐门外门弟子唐三，因偷学内门绝学被逐出师门。跳崖明志后，穿越到异界大陆——斗罗大陆。在这里，没有魔法，没有斗气，只有武魂。唐三能否凭借唐门绝学在这片大陆上再创辉煌？',
    status: '连载中',
    rating: 9.6,
    views: 35000000,
    tags: ['奇幻', '热血', '穿越', '战斗'],
    updateTime: '2026-08-03',
    latestChapter: '第612话',
    chapters: Array.from({ length: 612 }, (_, i) => ({
      id: `ch-3-${i + 1}`,
      title: `第${i + 1}话`,
      updateTime: `2026-${String(Math.max(1, 8 - Math.floor(i / 80))).padStart(2, '0')}-${String(Math.max(1, 31 - (i % 30))).padStart(2, '0')}`,
    })),
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 'comic-4',
    title: '咒术回战',
    author: '芥见下下',
    category: '日漫',
    categorySlug: 'riman',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20stylish%20Japanese%20manga%20cover%20featuring%20a%20white%20haired%20man%20wearing%20a%20black%20blindfold%20with%20a%20confident%20smirk%2C%20modern%20urban%20fantasy%20setting%20with%20cursed%20energy%20swirling%20in%20purple%20and%20dark%20tones%2C%20cool%20and%20edgy%20aesthetic%2C%20jujutsu%20sorcerer%20theme%2C%20clean%20composition%20with%20dynamic%20angle&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    description: '高中生虎杖悠仁意外吞下诅咒之王两面宿傩的手指，成为了宿傩的容器。为了收集散落各地的宿傩手指，虎杖加入了东京都立咒术高等专门学校，开始了与诅咒战斗的生活。',
    status: '连载中',
    rating: 9.7,
    views: 42000000,
    tags: ['动作', '奇幻', '热血', '黑暗'],
    updateTime: '2026-08-04',
    latestChapter: '第271话',
    chapters: Array.from({ length: 271 }, (_, i) => ({
      id: `ch-4-${i + 1}`,
      title: `第${i + 1}话`,
      updateTime: `2026-${String(Math.max(1, 8 - Math.floor(i / 40))).padStart(2, '0')}-${String(Math.max(1, 30 - (i % 30))).padStart(2, '0')}`,
    })),
    isHot: true,
    isNew: false,
    isRecommended: false,
  },
  {
    id: 'comic-5',
    title: '反派千金的生存法则',
    author: '星星糖',
    category: '韩漫',
    categorySlug: 'hanman',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20romantic%20fantasy%20webtoon%20cover%20featuring%20a%20elegant%20noblewoman%20with%20silver%20hair%20in%20a%20lavish%20Victorian%20style%20dress%2C%20holding%20a%20fan%2C%20palace%20interior%20background%20with%20chandeliers%20and%20roses%2C%20soft%20romantic%20color%20palette%20in%20rose%20gold%20and%20cream%2C%20otome%20isekai%20aesthetic%2C%20elegant%20portrait%20composition&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    description: '一觉醒来发现自己穿越成了小说中的反派千金！按照原著剧情，等待我的只有悲惨的结局。为了改变命运，我决定跟男主角保持距离，可为什么他们反而一个个地靠过来了？',
    status: '连载中',
    rating: 9.3,
    views: 12800000,
    tags: ['恋爱', '奇幻', '穿越', '恶役千金'],
    updateTime: '2026-08-04',
    latestChapter: '第156话',
    chapters: Array.from({ length: 156 }, (_, i) => ({
      id: `ch-5-${i + 1}`,
      title: `第${i + 1}话`,
      updateTime: `2026-${String(Math.max(1, 8 - Math.floor(i / 25))).padStart(2, '0')}-${String(Math.max(1, 30 - (i % 30))).padStart(2, '0')}`,
    })),
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 'comic-6',
    title: '一人之下',
    author: '米二',
    category: '国漫',
    categorySlug: 'guoman',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Chinese%20comic%20cover%20featuring%20a%20young%20man%20with%20short%20black%20hair%20in%20casual%20modern%20clothes%2C%20surrounded%20by%20mystical%20Taoist%20talisman%20symbols%20and%20glowing%20energy%2C%20modern%20urban%20Chinese%20setting%20blended%20with%20ancient%20mystical%20elements%2C%20earthy%20warm%20tones%2C%20dynamic%20composition%2C%20clean%20manhua%20style&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    description: '普通大学生张楚岚，因爷爷尸体被盗而卷入异人世界的纷争。在这个充满异能者的世界里，他逐渐揭开了爷爷隐藏的秘密，以及自己身上那不为人知的力量。',
    status: '连载中',
    rating: 9.4,
    views: 28000000,
    tags: ['动作', '奇幻', '都市', '异能'],
    updateTime: '2026-08-03',
    latestChapter: '第688话',
    chapters: Array.from({ length: 688 }, (_, i) => ({
      id: `ch-6-${i + 1}`,
      title: `第${i + 1}话`,
      updateTime: `2026-${String(Math.max(1, 8 - Math.floor(i / 100))).padStart(2, '0')}-${String(Math.max(1, 31 - (i % 30))).padStart(2, '0')}`,
    })),
    isHot: false,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 'comic-7',
    title: '秘密课程',
    author: '蜂蜜柚子',
    category: '韩漫',
    categorySlug: 'hanman',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20webtoon%20cover%20showing%20a%20beautiful%20female%20teacher%20with%20glasses%20and%20a%20male%20student%20in%20a%20classroom%20setting%2C%20soft%20sunlight%20streaming%20through%20windows%2C%20forbidden%20romance%20theme%2C%20warm%20amber%20and%20cream%20tones%2C%20romantic%20atmosphere%2C%20clean%20illustration%20with%20delicate%20expressions&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    description: '新来的实习老师竟然是高中时的暗恋对象？已经是大学生的我，该如何面对这段跨越师生身份的禁忌之恋？甜蜜又心动的秘密课程，就此开始。',
    status: '连载中',
    rating: 9.1,
    views: 9600000,
    tags: ['恋爱', '校园', '师生', '年下'],
    updateTime: '2026-08-04',
    latestChapter: '第89话',
    chapters: Array.from({ length: 89 }, (_, i) => ({
      id: `ch-7-${i + 1}`,
      title: `第${i + 1}话`,
      updateTime: `2026-${String(Math.max(1, 8 - Math.floor(i / 15))).padStart(2, '0')}-${String(Math.max(1, 30 - (i % 30))).padStart(2, '0')}`,
    })),
    isHot: false,
    isNew: true,
    isRecommended: false,
  },
  {
    id: 'comic-8',
    title: '葬送的芙莉莲',
    author: '山田钟人',
    category: '日漫',
    categorySlug: 'riman',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20fantasy%20manga%20cover%20featuring%20an%20elf%20girl%20with%20long%20silver%20hair%20and%20a%20gentle%20melancholic%20expression%2C%20wearing%20a%20white%20robe%2C%20holding%20a%20staff%2C%20walking%20through%20a%20field%20of%20wildflowers%20under%20a%20blue%20sky%20with%20fluffy%20clouds%2C%20nostalgic%20and%20bittersweet%20atmosphere%2C%20soft%20pastel%20watercolor%20aesthetic&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    description: '打倒魔王的勇者队伍中的魔法使芙莉莲，身为精灵的她拥有漫长的寿命。在勇者去世后，她踏上了理解人类情感的旅程。一段关于时间、生命与羁绊的温柔故事。',
    status: '连载中',
    rating: 9.9,
    views: 31000000,
    tags: ['奇幻', '冒险', '治愈', '人生'],
    updateTime: '2026-08-02',
    latestChapter: '第140话',
    chapters: Array.from({ length: 140 }, (_, i) => ({
      id: `ch-8-${i + 1}`,
      title: `第${i + 1}话`,
      updateTime: `2026-${String(Math.max(1, 8 - Math.floor(i / 20))).padStart(2, '0')}-${String(Math.max(1, 30 - (i % 30))).padStart(2, '0')}`,
    })),
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 'comic-9',
    title: '全职高手',
    author: '蝴蝶蓝',
    category: '国漫',
    categorySlug: 'guoman',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Chinese%20esports%20manhua%20cover%20featuring%20a%20cool%20male%20character%20with%20short%20black%20hair%2C%20wearing%20a%20red%20and%20black%20gaming%20team%20jacket%2C%20holding%20a%20gaming%20mouse%2C%20cyberpunk%20style%20background%20with%20glowing%20keyboard%20and%20battle%20effects%2C%20competitive%20esports%20atmosphere%2C%20dynamic%20composition%2C%20clean%20illustration&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    description: '被誉为"荣耀教科书"的顶级高手叶修，遭到俱乐部驱逐后，栖身于一家网吧。当荣耀第十区开服，他带着新号"君莫笑"重新投入游戏，开启重返巅峰之路。',
    status: '已完结',
    rating: 9.5,
    views: 22000000,
    tags: ['电竞', '热血', '竞技', '友情'],
    updateTime: '2026-06-20',
    latestChapter: '第536话（完）',
    chapters: Array.from({ length: 536 }, (_, i) => ({
      id: `ch-9-${i + 1}`,
      title: `第${i + 1}话`,
      updateTime: `2025-${String(Math.max(1, 12 - Math.floor(i / 50))).padStart(2, '0')}-${String(Math.max(1, 28 - (i % 28))).padStart(2, '0')}`,
    })),
    isHot: false,
    isNew: false,
    isRecommended: false,
  },
  {
    id: 'comic-10',
    title: '某天成为公主',
    author: 'PLUTO',
    category: '韩漫',
    categorySlug: 'hanman',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20fantasy%20webtoon%20cover%20featuring%20a%20cute%20young%20princess%20with%20long%20blonde%20hair%20and%20big%20blue%20eyes%20in%20a%20pink%20princess%20gown%2C%20royal%20palace%20background%20with%20sparkling%20magic%20effects%2C%20father%20daughter%20bonding%20theme%2C%20warm%20golden%20and%20pink%20tones%2C%20fairy%20tale%20atmosphere%2C%20clean%20illustration&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    description: '醒来发现自己成了小说中的公主——而且是注定要被亲生父亲杀死的悲催公主！为了活命，我决定讨好这位冷血皇帝父亲。可是…他怎么变得越来越温柔了？',
    status: '已完结',
    rating: 9.6,
    views: 16500000,
    tags: ['恋爱', '奇幻', '穿越', '亲情'],
    updateTime: '2026-05-10',
    latestChapter: '第125话（完）',
    chapters: Array.from({ length: 125 }, (_, i) => ({
      id: `ch-10-${i + 1}`,
      title: `第${i + 1}话`,
      updateTime: `2025-${String(Math.max(1, 11 - Math.floor(i / 15))).padStart(2, '0')}-${String(Math.max(1, 28 - (i % 28))).padStart(2, '0')}`,
    })),
    isHot: false,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 'comic-11',
    title: '间谍过家家',
    author: '远藤达哉',
    category: '日漫',
    categorySlug: 'riman',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20funny%20and%20stylish%20manga%20cover%20featuring%20a%20fake%20family%20of%20three%20people:%20a%20suave%20man%20in%20a%20green%20suit%2C%20a%20beautiful%20woman%20in%20a%20red%20dress%2C%20and%20a%20cute%20little%20girl%20with%20pink%20hair%20and%20a%20stuffed%20toy%2C%20spy%20theme%20with%20vintage%201960s%20aesthetic%2C%20warm%20retro%20color%20palette%2C%20playful%20atmosphere&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    description: '为了执行秘密任务，顶级间谍"黄昏"需要组建一个临时家庭。他找到的妻子是杀手，领养的女儿是超能力者。这个互不知情的家庭，却意外地温暖了起来。',
    status: '连载中',
    rating: 9.8,
    views: 48000000,
    tags: ['搞笑', '日常', '间谍', '亲情'],
    updateTime: '2026-08-04',
    latestChapter: '第105话',
    chapters: Array.from({ length: 105 }, (_, i) => ({
      id: `ch-11-${i + 1}`,
      title: `第${i + 1}话`,
      updateTime: `2026-${String(Math.max(1, 8 - Math.floor(i / 15))).padStart(2, '0')}-${String(Math.max(1, 30 - (i % 30))).padStart(2, '0')}`,
    })),
    isHot: true,
    isNew: false,
    isRecommended: false,
  },
  {
    id: 'comic-12',
    title: '大王饶命',
    author: '会说话的肘子',
    category: '国漫',
    categorySlug: 'guoman',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20humorous%20Chinese%20manhua%20cover%20featuring%20a%20smirking%20young%20man%20with%20casual%20modern%20outfit%2C%20surrounded%20by%20floating%20spirit%20energy%20and%20a%20mischievous%20little%20spirit%20creature%2C%20urban%20cultivation%20setting%20with%20Chinese%20mythological%20elements%2C%20comedic%20atmosphere%2C%20bright%20and%20lively%20color%20scheme&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    description: '灵气复苏时代，吕树依靠怼人获取负面情绪值来修炼升级。靠着毒舌和收集他人怒气值的能力，他一步步走上强者之路。贱萌搞笑的都市修仙生活就此展开。',
    status: '连载中',
    rating: 9.2,
    views: 15600000,
    tags: ['搞笑', '都市', '修仙', '毒舌'],
    updateTime: '2026-08-03',
    latestChapter: '第492话',
    chapters: Array.from({ length: 492 }, (_, i) => ({
      id: `ch-12-${i + 1}`,
      title: `第${i + 1}话`,
      updateTime: `2026-${String(Math.max(1, 8 - Math.floor(i / 70))).padStart(2, '0')}-${String(Math.max(1, 31 - (i % 30))).padStart(2, '0')}`,
    })),
    isHot: false,
    isNew: true,
    isRecommended: false,
  },
];

export const getComicById = (id: string): ComicItem | undefined => {
  return comics.find((c) => c.id === id);
};

export const getComicsByCategory = (slug: string): ComicItem[] => {
  return comics.filter((c) => c.categorySlug === slug);
};

export const getHotComics = (limit: number = 10): ComicItem[] => {
  return [...comics].filter((c) => c.isHot).sort((a, b) => b.views - a.views).slice(0, limit);
};

export const getRecommendedComics = (limit: number = 8): ComicItem[] => {
  return comics.filter((c) => c.isRecommended).slice(0, limit);
};

export const getNewComics = (limit: number = 10): ComicItem[] => {
  return [...comics].sort((a, b) => new Date(b.updateTime).getTime() - new Date(a.updateTime).getTime()).slice(0, limit);
};

export const getPopularComics = (limit: number = 10): ComicItem[] => {
  return [...comics].sort((a, b) => b.views - a.views).slice(0, limit);
};